module.exports = __webpack_public_path__ + "img/1551995247.b4d7e59c.jpg";